module.exports = __webpack_public_path__ + "static/media/halcyonNew.127c76b8.jpeg";